<div [id]="modalId" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" [ngClass]="sizeClass" role="document">
        <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header" *ngIf="showHeader">
                <button type="button" class="close" (click)="close()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" *ngIf="title">{{ title }}</h4>
                <ng-content select="[modal-header]"></ng-content>
            </div>

            <!-- Modal Body -->
            <div class="modal-body">
                <ng-content select="[modal-body]"></ng-content>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer" *ngIf="showFooter">
                <ng-content select="[modal-footer]"></ng-content>
            </div>
        </div>
    </div>
</div>
